import Vue from 'vue';
import Swiper from '@app/components/Layout/Swiper.vue';
import Lightbox from '@app/components/Lightbox.vue';
export default Vue.extend({
    props: {
        block: Object
    },
    components: {
        Swiper: Swiper,
        Lightbox: Lightbox
    },
    data: function () { return ({
        currentImageIndex: null
    }); },
    methods: {
        openInLightbox: function (index) {
            this.currentImageIndex = index;
        }
    }
});
